import { useQuery } from 'react-query';

import { useRequest, getTeamMemberListKey } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type {
  TeamMemberData,
  UseTeamMemberListParams,
  TeamMemberListQueryKey,
} from './types';

export const useTeamMemberList: QueryFunction<
  TeamMemberData[],
  [UseTeamMemberListParams],
  TeamMemberListQueryKey
> = (params, { requestOptions, queryOptions, query } = {}) => {
  const queryKey = getTeamMemberListKey({ ...params, query });
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/${params.locator}/members`, {
        query,
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
